import { useQuery } from 'react-query'
import * as contentService from 'services/content'
import { Content } from './types'
import { useDailyClassPlan } from 'pages/Programming/hooks'
import { AffiliateWorkout } from 'pages/Programming/types'
import { format } from 'date-fns'
import { useAffiliate } from 'hooks/useAffiliate'

function useDashboard() {
  const { canAccessDashboard } = useAffiliate()

  const dailyClassPlan = useDailyClassPlan(
    'affiliate',
    format(new Date(), 'yyyyMMdd'),
  )
  const rxWorkout = (dailyClassPlan.data?.workouts as AffiliateWorkout[])?.find(
    (w) => w.level === 'rx',
  )
  const contentQuery = useQuery(
    'dashboard-en-us',
    () =>
      contentService
        .fetchPath<Content>('/affiliate-dashboards/dashboard-en-us')
        .then((content) => {
          return {
            ...content,
            upcomingEvents: {
              ...content.upcomingEvents,
              affiliateEvents: content.upcomingEvents.affiliateEvents.sort(
                (a, b) =>
                  new Date(a.startDateTime).getTime() -
                  new Date(b.startDateTime).getTime(),
              ),
            },
          }
        }),
    { enabled: canAccessDashboard },
  )

  return {
    hasAccess: canAccessDashboard,
    content: contentQuery.data,
    dailyClassPlan,
    rxWorkout,
    isLoading: contentQuery.isLoading || dailyClassPlan.isLoading,
  }
}

export default useDashboard
